module.exports = __webpack_public_path__ + "static/img/ziliao7.9d4aa2e7.png";